module.exports = __webpack_public_path__ + "static/media/flyerB.329f5814.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/flyerB.svg
// module id = 547
// module chunks = 0